import { ChangeDetectionStrategy, Component, ViewEncapsulation, OnInit, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { MatFormFieldControlBase } from '@fi-shared/widget/mat-form-field-control-base';
import { ICheckpointActionSettings } from '@fi-shared/checklist/checklist-v2';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ObjectTypes } from '@fi-shared/types';
import { FiCheckpoint2HelperService } from '@fi-app/shared/checklist/fi-checkpoint2-helper.service';
import { CheckpointActionConditionType } from '@fi-app/shared/checklist/checklist-enum';

@Component({
    selector: 'fi-checkpoint-action-task-name',
    templateUrl: './action-task-name.component.html',
    styleUrls: ['./action-task-name.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checkpoint-action-task-name' },
    providers: [
        {
            provide: MatFormFieldControl,
            useExisting: FiCheckpointActionTaskNameComponent,
        },
    ],
    standalone: false,
})
export class FiCheckpointActionTaskNameComponent
    extends MatFormFieldControlBase<ICheckpointActionSettings>
    implements OnInit
{
    @Input({ required: true }) actionCondition: CheckpointActionConditionType;
    @Input() checkpointName: string;
    @Input() checklistName: string;
    protected readonly ObjectTypes = ObjectTypes;
    private fiCheckpoint2HelperService: FiCheckpoint2HelperService;

    public ngOnInit(): void {
        this.setServices();
    }

    public doValidate(c: AbstractControl): ValidationErrors {
        return {
            taskNameRequired: !this.ngModel.TaskName?.trim().length,
        };
    }

    protected getPredefinedTaskDescription(): string {
        return this.fiCheckpoint2HelperService.getCheckpointTaskNameByActionCondition(
            this.actionCondition,
            this.checkpointName,
            this.checklistName,
        );
    }

    private setServices(): void {
        this.fiCheckpoint2HelperService = this.injector.get(FiCheckpoint2HelperService);
    }
}
